// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_n1-0";